import Vue from 'vue'

import withRender from './actionable-rating-stars.html'
import './rating-stars.scss'

export default withRender(Vue.extend({
  data() {
    return { hoverRating: 0 }
  },
  props: {
    starSize: {
      type: String,
      default: 'xxl'
    },
    value: { // rating, set via v-model
      type: Number,
      default: 0
    }
  },
  computed: {
    rating() {
      return this.hoverRating || this.value
    }
  },
  methods: {
    ratingSelected(rating) {
      this.$emit('input', rating)
    },
    ratingEnter(rating) {
      this.hoverRating = rating
    },
    ratingLeave() {
      this.hoverRating = 0
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/rating/actionable-rating-stars.ts